import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync, TS_Video } from '@nu-art/thunderstorm-frontend/index';
export class Render_Support_Video extends ComponentSync {
    wrapperRef = React.createRef();
    //######################### Life Cycle #########################
    __onWindowResized() {
        this.updateDimensions();
    }
    deriveStateFromProps(nextProps, state) {
        state.faq = nextProps.faq;
        return state;
    }
    componentDidMount() {
        this.updateDimensions();
    }
    //######################### Logic #########################
    updateDimensions = () => {
        const rect = this.wrapperRef.current?.getBoundingClientRect();
        if (!rect)
            return;
        this.setState({ width: rect.width, height: rect.height });
    };
    //######################### Render #########################
    render() {
        const source = { url: this.state.faq.videoUrl, format: 'mp4' };
        return _jsx("div", { className: 'support__faq-video', ref: this.wrapperRef, children: _jsx(TS_Video, { source: source, configuration: {
                    controls: { noDownload: true },
                    autoplay: true,
                }, width: this.state.width ?? 0, height: this.state.height ?? 0 }) });
    }
}
//# sourceMappingURL=Render_Support_Video.js.map